import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-300">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="text-xl font-heading font-bold text-background-50 hover:text-primary-400 transition-colors">
              久久视频
            </Link>
            <p className="mt-3 text-sm text-background-400 leading-relaxed">
              高清视频在线观看平台，汇聚海量影视、综艺、短视频内容，让每一次观看都成为享受。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-100 mb-4">内容分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-100 mb-4">更多分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors"
                >
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-medium text-background-100 mb-4">联系我们</h4>
            <ul className="space-y-2.5 text-sm text-background-400">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <span>contact@jiujiu.video</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line"></i>
                <span>400-888-9999</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line"></i>
                <span>北京市朝阳区建国路88号</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-background-500">
          <p>&copy; 2020 - 2026 久久视频 版权所有</p>
          <div className="flex items-center gap-6">
            <a href="https://weibo.com/jiujiuvideo" target="_blank" rel="nofollow noopener noreferrer" className="hover:text-primary-400 transition-colors">
              <i className="ri-weibo-line"></i> 微博
            </a>
            <span className="hover:text-primary-400 transition-colors cursor-pointer">
              <i className="ri-wechat-line"></i> 微信
            </span>
            <span className="hover:text-primary-400 transition-colors cursor-pointer">
              <i className="ri-tiktok-line"></i> 抖音
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}